export function findFirstInDOM(elements: HTMLElement[]): HTMLElement | null {
    return elements.reduce<HTMLElement | null>((first, current) => {
        if (!first) {
            return current;
        }
        // eslint-disable-next-line no-bitwise
        return first.compareDocumentPosition(current) & Node.DOCUMENT_POSITION_PRECEDING ? current : first;
    }, null);
}
